export const disableOptions = (options, targets, value) => {
  const updatedOptions = [...options];
  targets.forEach(target => {
    updatedOptions.forEach(option => {
      if (option.fields.value === target) {
        // eslint-disable-next-line no-param-reassign
        option.fields.disabledOption = value;
      }
    });
  });
  return updatedOptions;
};
